/**
 * Random business codename generator for Uroborox listings.
 * Format: "Proyecto Name" — palabra fija "Proyecto" + nombre aleatorio.
 *
 * Fuente única: ./codenames.json (600 nombres).
 */

import NAMES from './codenames.json';

/**
 * Generate a random codename for a listing.
 * @returns {string} e.g. "Proyecto Abedul", "Proyecto Abeto"
 */
export const generateCodename = () => {
  const name = NAMES[Math.floor(Math.random() * NAMES.length)];
  return `Proyecto ${name}`;
};
